import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import api from 'mastodon/api';

import { IconButton } from 'mastodon/components/icon_button';
import { LaoFlag } from 'mastodon/components/icons/lao_flag';
import { VietNamFlag } from 'mastodon/components/icons/vietnam_flag';
import { UnitedKingdomFlag } from 'mastodon/components/icons/united_kingdom_flag';

import { showAlert } from 'mastodon/actions/alerts';
import { useAppDispatch } from 'mastodon/store';

import { CloseIcon } from 'mastodon/components/icons/close';

const messages = {
  title: { id: 'language.title', defaultMessage: 'Choose language' },
  description: { id: 'language.description', defaultMessage: 'Choose your language to enhance accessibility and understanding' },
  close: { id: 'bundle_modal_error.close', defaultMessage: 'Close' },
  lao: { id: 'language.lao', defaultMessage: 'Lao' },
  vietnamese: { id: 'language.vietnamese', defaultMessage: 'Vietnamese' },
  english: { id: 'language.english', defaultMessage: 'English' },
};

const LanguageModal = ({ onClose, currentLocale }) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();

  const handleLanguageChange = (newLocale) => {
    api()
      .put('/api/v1/preferences', { locale: newLocale, chosen_languages: [newLocale] })
      .then(() => {
        dispatch(showAlert({ message: intl.formatMessage({ id: 'language.change_success', defaultMessage: 'Language changed successfully' }) }));
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating locale:', error);
        dispatch(showAlert({ message: intl.formatMessage({ id: 'language.change_error', defaultMessage: 'Failed to update language' }) }));
      });
  };

  const languages = [
    { code: 'lo', label: 'ລາວ', icon: LaoFlag },
    { code: 'vi', label: 'Việt Nam', icon: VietNamFlag },
    { code: 'en', label: 'United Kingdom', icon: UnitedKingdomFlag },
  ];

  return (
    <div className={classNames('modal-root__modal', 'language-modal')}>
      <div className='language-modal-container'>
        <div className='language-modal__header'>
          <h3>{intl.formatMessage(messages.title)}</h3>
          <IconButton
            className='language-modal__close'
            title={intl.formatMessage(messages.close)}
            icon='close'
            iconComponent={CloseIcon}
            onClick={onClose}
            size={20}
          />
        </div>
        <div className='language-modal__content'>
            {languages.map(({ code, label, icon: Icon }) => (
              <div
                key={code}
                className={classNames('language-modal__item', { active: currentLocale === code })}
                onClick={() => handleLanguageChange(code)}
                role='button'
                tabIndex={0}
                onKeyPress={(e) => e.key === 'Enter' && handleLanguageChange(code)}
              >
                <Icon />
                <p>{label}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

LanguageModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
};

export default LanguageModal;
